import React, { useEffect, useState } from "react";
import { DialogWrapMedium } from "../../../controls/components/dialogWrap/DialogWrap";
import { UserFormServiceButtonClose, UserFormServiceButtonCreated } from "../../MyBooking/styled/DesStyled";
import { startStationImpersonation } from "../../../../services/StationImpersonationService";

/** Lý do mặc định gửi kèm (backend vẫn đòi lý do ≥5 ký tự); nhật ký vẫn ghi người mở + station. */
const DEFAULT_REASON = "Admin xem với tư cách station";

/**
 * Hộp xác nhận trước khi mở phiên "Xem với tư cách station".
 * 05/10/2026 Quân chốt bỏ ô nhập lý do — bấm "Mở phiên xem" là mở luôn.
 */
export default function DialogImpersonateStation(props: {
	openDialog: boolean;
	setOpenDialog: (v: boolean) => void;
	partnerId: string | null;
	stationName?: string | null;
}) {
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (props.openDialog) {
			setError(null);
			setSubmitting(false);
		}
	}, [props.openDialog]);

	const handleConfirm = async () => {
		if (!props.partnerId) return;
		setSubmitting(true);
		setError(null);
		// Safari chặn window.open nếu gọi SAU một await (mất "cử chỉ người dùng") ⇒ mở tab trống
		// NGAY trong lúc bấm, chờ API xong mới trỏ tab đó tới URL. Không truyền "noopener" ở đây vì
		// khi đó window.open trả về null; thay bằng cắt opener thủ công trước khi điều hướng.
		const tab = window.open("", "_blank");
		try {
			const session = await startStationImpersonation(props.partnerId, DEFAULT_REASON);
			if (tab && !tab.closed) {
				tab.opener = null;
				tab.location.href = session.url;
			} else {
				window.open(session.url, "_blank", "noopener,noreferrer");
			}
			props.setOpenDialog(false);
		} catch (err: any) {
			tab?.close();
			setError(err?.response?.data?.message || "Không mở được phiên xem. Thử lại hoặc báo kỹ thuật.");
		} finally {
			setSubmitting(false);
		}
	};

	const canConfirm = !!props.partnerId && !submitting;

	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => props.setOpenDialog(false)}
			title="Xem với tư cách station"
			actions={
				<>
					<UserFormServiceButtonClose
						type="button"
						onClick={() => props.setOpenDialog(false)}>
						Huỷ
					</UserFormServiceButtonClose>
					<UserFormServiceButtonCreated
						type="button"
						disabled={!canConfirm}
						style={canConfirm ? undefined : { opacity: 0.5, cursor: "not-allowed" }}
						onClick={() => void handleConfirm()}>
						{submitting ? "Đang mở…" : "Mở phiên xem"}
					</UserFormServiceButtonCreated>
				</>
			}>
			{/* DialogWrapMedium chỉ nhận MỘT children (string | Element), nên gói tất cả vào một div */}
			<div>
				{props.stationName ? (
					<p style={{ margin: "0 0 10px", fontSize: 14, fontWeight: 600 }}>{props.stationName}</p>
				) : null}

				<ul style={{ margin: "0 0 14px", paddingLeft: 18, fontSize: 13, lineHeight: 1.7, color: "#374151" }}>
					<li>Mở portal của station này trong tab mới, ở chế độ chỉ đọc.</li>
					<li>Không dùng và không đổi mật khẩu của họ — station vẫn đăng nhập bình thường.</li>
					<li>Mọi thao tác ghi dữ liệu đều bị chặn. Phiên tự hết hạn sau 30 phút.</li>
					<li>Lần mở này được ghi nhật ký kèm tên bạn.</li>
				</ul>


				{error ? <p style={{ marginTop: 10, fontSize: 13, color: "#c62828" }}>{error}</p> : null}

				<p
					style={{
						marginTop: 12,
						padding: "8px 10px",
						fontSize: 12,
						lineHeight: 1.6,
						color: "#8a4a08",
						background: "#fdf1de",
						border: "1px solid #e3b571",
						borderRadius: 6,
					}}>
					Phiên xem <strong>chỉ đọc</strong>, tự hết hạn sau 30 phút. Station không bị đăng xuất và không
					nhận thông báo gì.
				</p>
			</div>
		</DialogWrapMedium>
	);
}
